module.exports = __webpack_public_path__ + "img/Sagittarius.5c792a20.png";